import { memo } from "react";
import Select from "react-select";

const Input = ({
  type,
  handleChange = () => {},
  k,
  options = [],
  readonly = false,
  value,
  isMulti = false,
  isClearable = false,
}) => {
  if (type === "option") {
    let defaultValue = [];
    if (value && Array.isArray(value)) {
      for (const item of value) {
        const index = options.findIndex(({ value }) => value === item);
        if (index > -1) {
          defaultValue.push(options[index]);
        }
      }
    }

    return (
      <Select
        options={options}
        isMulti={isMulti}
        isClearable={isClearable}
        value={defaultValue}
        onChange={(options) => {
          let value = [];
          if (!options) {
            return handleChange({
              key: k,
              value: null,
            });
          }
          if (Array.isArray(options)) {
            value = options.map((option) => option.value);
          } else {
            value.push(options.value);
          }
          handleChange({
            key: k,
            value,
          });
        }}
        styles={{
          menuList: (base) => ({
            ...base,
            maxHeight: "300px",
            fontFamily: "UTM Avo , sans-serif !important",
          }),

          menu: (base) => ({
            ...base,
            zIndex: 99999,
          }),
        }}
      />
    );
  }

  return (
    <input
      className="form-control"
      type={type}
      defaultValue={value}
      readOnly={readonly}
      onChange={({ target: { value } }) => {
        handleChange({ key: k, value });
      }}
    />
  );
};

const Component = ({ label, required, errorMessage, ...props }) => {
  const { col } = props;
  return (
    <div className={`col-sm-${col ? col : "4"} mb-2`}>
      <label className="label">
        {label}
        {required && <span className="red_star ml-1">*</span>}
      </label>
      <Input {...props} />
      {errorMessage ? (
        <p className="error-message m-0">{errorMessage}</p>
      ) : null}
    </div>
  );
};

export const Item = memo(Component, (prevProps, newProps) => {
  const { handleChange, options, ...props } = prevProps;
  for (const k in props) {
    if (props[k] !== newProps[k]) {
      return false;
    }
  }

  if (options?.length !== newProps?.options?.length) {
    return false;
  }

  return true;
});
